import { render } from "./index.vue?vue&type=template&id=cf69b560"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cf69b560&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__